var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-style"},[_c('div',{staticClass:"map-title"},[_c('span',[_vm._v("全国案件判例")]),_c('span',[_vm._v("不完全统计")])]),_c('div',{staticClass:"map-content"},[_c('div',{attrs:{"id":"main"}}),_c('div',{attrs:{"id":"count-style"}})])])
}]

export { render, staticRenderFns }